"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickAndPackRule = void 0;
const lodash_1 = __importDefault(require("lodash"));
class PickAndPackRule {
    constructor(definition) {
        this.definition = definition ?? {};
    }
    static pickAndPackRuleFromProps(options) {
        const definition = {
            pickAndPack: {
                date: options.date,
                blocked: true,
            },
        };
        return new PickAndPackRule(definition);
    }
    getDefinition() {
        return this.definition;
    }
    isBlocked() {
        return (!!this.definition.pickAndPack && !!this.definition.pickAndPack.blocked);
    }
    getKey() {
        return this.definition.pickAndPack?.date ?? null;
    }
    getDate() {
        return this.definition.pickAndPack?.date;
    }
    setDate(date) {
        lodash_1.default.set(this.definition, 'pickAndPack.date', date);
    }
    setBlocked(blocked) {
        lodash_1.default.set(this.definition, 'pickAndPack.blocked', blocked);
    }
    exportAsDeliveryRuleDefinition() {
        return this.definition;
    }
}
exports.PickAndPackRule = PickAndPackRule;
